<template>
	<fieldset id="fs-annual-schematic" class="pt-3 pb-3">
		<div class="container pt-5 pb-3">
			<div class="row no-gutters">
				<div class="fieldset-title">
					<i class="icon"><svg aria-hidden="true">
							<use xlink:href="/static/build/gfx/sprite.svg#icon-recirc"></use>
						</svg></i>
					<h2 class="heading">Piping Configuration</h2>
				</div>
			</div>

			<div class="row justify-content-between no-gutters">
				<div class="col-9 col-xxl-8">
					<div class="row no-gutters">
						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'swingtank',
									}"
									@click="formData.schematic = 'swingtank'"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/svg+xml"
											data="/static/build/gfx/schematic-swingtank.svg"
											class="schematic"></object>
									</figure>

									<div class="btn">
										<span>Swing Tank</span></div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>

									<p class="locked">
										<i class="symbol help left">
											<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-disabled.svg" />
										</i>

										<span id="nomulti d-none">Not available with Multi Pass selected</span>
									</p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'paralleltank',
									}"
									@click="formData.schematic = 'paralleltank'"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/svg+xml"
											data="/static/build/gfx/schematic-paralleltank.svg"
											class="schematic"></object>
									</figure>

									<div class="btn">
										<span>Parallel Loop Tank</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
									<p class="locked">
																			<i class="symbol help left">
												<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-disabled.svg"></object>
										</i>
										<span id="nomulti d-none">Not available with Multi Pass selected</span>
									</p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'sprtp',
									}"
									@click="formData.schematic = 'sprtp'"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/jpg"
											data="/static/build/gfx/schematic-singlepassRTP.svg"
											class="schematic"></object>
									</figure>

									<div class="btn">
										<span>Single Pass - Return to Primary</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>

									<p class="locked">
										<i class="symbol help left">
											<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-disabled.svg" />
										</i>

										<span id="nomulti d-none">Not available with Multi Pass selected</span>
									</p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'singlepass_norecirc',
									}"
									@click="formData.schematic = 'singlepass_norecirc'"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/jpg"
											data="/static/build/gfx/schematic-primary.svg"
											class="schematic"></object>
									</figure>

									<div class="btn">
										<span>Single Pass - No Recirculation</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>

									<p class="locked">
										<i class="symbol help left">
											<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-disabled.svg" />
										</i>

										<span id="nomulti d-none">Not available with Multi Pass selected</span>
									</p>
								</div>
							</div>
						</div>

						<!-- Multi Pass options hidden
						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'multipass_norecirc',
									}"
									@click="formData.schematic = 'multipass_norecirc'"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/jpg"
											data="/static/build/gfx/schematic-multipassNoRecirc.svg"
											class="schematic"></object>
									</figure>

									<div class="btn">
										<span>Multi Pass - No Recirculation</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
																	<p class="locked">
																			<i class="symbol help left">
												<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-disabled.svg"></object>
										</i>
										<span id="nomulti d-none">Not available with Single Pass selected</span>
									</p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'mprtp',
									}"
									@click="formData.schematic = 'mprtp'"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/jpg"
											data="/static/build/gfx/schematic-multipassRTP.svg"
											class="schematic"></object>
									</figure>

									<div class="btn">
										<span>Multi Pass - Return to Primary</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
																	<p class="locked">
																			<i class="symbol help left">
												<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-disabled.svg"></object>
										</i>
										<span id="nomulti d-none">Not available with Single Pass selected</span>
									</p>
								</div>
							</div>
						</div>
						-->
					</div>
				</div>

				<div class="col-3 pl-3 pl-xxl-0">
					<p>A temperature maintenance system provides hot water to the taps in a timely manner.</p>
				</div>
			</div>

			<div class="row mt-2">
			</div>

			<div class="row mt-5 clearfix">

			</div>

		</div>
	</fieldset>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'TempMaintSystSelect',

	data: () => ({
		formData,
	}),
}
</script>
